<template>
	<div
			class="card"
	>
		<vue-headful
				:title="title">
		</vue-headful>
		<b-modal
				v-model="showUpdateReg"
				:title="'Update Registration ' + record.fieldData['Registration Number']"
				class-name="my-modal-wrap"
				:footer-hide="hideRegFooter"
				@on-cancel="resetUpdateRegistration"
				fullscreen
		>
			<FeedbackPanel></FeedbackPanel>
			<vue-dropzone
					ref="myVueDropzone"
					id="dropzone"
					:options="dropzoneOptions"
					@vdropzone-success="uploadSuccess"
					@vdropzone-error="uploadError"
					@vdropzone-file-added="fileAdded"
			></vue-dropzone>
		</b-modal>
		<b-modal
				v-model="showReg"
				:title="record.fieldData['Registration Number']"
				class-name="my-modal-wrap"
				:footer-hide="hideRegFooter"
				fullscreen
		>
			<div class="pic-slide">
				<img :src="record.fieldData['Registration Picture']" class="mb-1" style="max-height: 95%"/>
			</div>
		</b-modal>
		<div class="card-body">
			<FeedbackPanel></FeedbackPanel>
			<div class="card-title">
				<div class="row">
					<h5 class="col-6"><strong>Registration {{ record.fieldData['Registration Number'] }}</strong></h5>
					<h5 class="col-6 text-right"><strong>{{ record.fieldData['Activity'] }}</strong></h5>
				</div>
				<div class="row">
					<div class="col-12" style="padding-bottom: 1em;">
						<a href="#" @click.prevent="viewRegistration" v-if="record.fieldData['Registration Picture']"
						   class="float-right">
							View Registration
							<font-awesome-icon icon="file-alt"></font-awesome-icon>
						</a>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<div class="card mb-3">
						<div id="reg-field" class="card-body">
							<div class="row">
								<div class="col-4">
									<label class="reg-label">Company ID</label>
									<div>{{ record.fieldData['Company ID'] }}</div>
								</div>
								<div class="col-8">
									<label class="reg-label">Company Name</label>
									<div>{{ record.fieldData['Company Name'] }}</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<label class="reg-label">Address 1</label>
									<div>{{ record.fieldData['Address 1'] }}</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<label class="reg-label">Address 2</label>
									<div>{{ record.fieldData['Address 2'] }}</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<label class="reg-label">Address 3</label>
									<div>{{ record.fieldData['Address 3'] }}</div>
								</div>
							</div>
							<div class="row">
								<div class="col-4">
									<label class="reg-label">City</label>
									<div>{{ record.fieldData['City'] }}</div>
								</div>
								<div class="col-2">
									<label class="reg-label">State</label>
									<div>{{ record.fieldData['State'] }}</div>
								</div>
								<div class="col-4">
									<label class="reg-label">Zip</label>
									<div>{{ record.fieldData['Zip'] }}</div>
								</div>
							</div>
							<div class="row">
								<div class="col-4">
									<label class="reg-label">Status</label>
									<div>{{ record.fieldData['Status Mask'] }}</div>
								</div>
								<div class="col-8">
									<label class="reg-label">Expiration Date</label>
									<div>{{ record.fieldData['Expiration Date'] }}</div>
								</div>
							</div>
							<div class="row">
								<div class="col-4">
									<label class="reg-label">Agency Type</label>
									<div>{{ record.fieldData['Federal/State License'] }}</div>
								</div>
								<div class="col-8" v-if="record.fieldData['Federal or State License'] === 'Federal'">
									<label class="reg-label">Agency</label>
									<div>{{ record.fieldData['Federal Agency'] }}</div>
								</div>
								<div class="col-8" v-if="record.fieldData['Federal or State License'] === 'State'">
									<label class="reg-label">Agency</label>
									<div>{{ record.fieldData['State Agency'] }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-3">
						<div class="card-header pt-2 pb-2">
							CSA Schedules
						</div>
						<div class="card-body">
							<div class="row" style="margin-top: 0.5em;">
								<div class="col-2 text-center">
									<label class="reg-label">1</label>
									<div>{{ record.fieldData['Schedule 1'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">1N</label>
									<div>{{ record.fieldData['Schedule 1N'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">2</label>
									<div>{{ record.fieldData['Schedule 2'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">2N</label>
									<div>{{ record.fieldData['Schedule 2N'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">3</label>
									<div>{{ record.fieldData['Schedule 3'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">3N</label>
									<div>{{ record.fieldData['Schedule 3N'] }}</div>
								</div>
							</div>
							<div class="row" style="margin-top: 1em;">
								<div class="col-2 text-center">
									<label class="reg-label">4</label>
									<div>{{ record.fieldData['Schedule 4'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">4N</label>
									<div>{{ record.fieldData['Schedule 4N'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">5</label>
									<div>{{ record.fieldData['Schedule 5'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">5N</label>
									<div>{{ record.fieldData['Schedule 5N'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">LC</label>
									<div>{{ record.fieldData['Schedule LC'] }}</div>
								</div>
								<div class="col-2 text-center">
									<label class="reg-label">NC</label>
									<div>{{ record.fieldData['Schedule NC'] }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6">
					<!--Registration-->
<!--					<div class="mb-3">
						<div class="card">
							<div class="card-header pb-2 pt-2">Registrations</div>
							<div class="card-body pt-2">
								<b-table
										id="registration-table"
										:fields="regFields "
										:items="record.portalData.Registration_Information_Record_Num"
										:per-page="regRowsPerPage"
										:current-page="regPage"
										primary-key="Registration_Information_Record_Num::Record_Number_PK_ID"
										small
										responsive
										hover
								>
									<template v-slot:cell(view)="data" style="width: 28px;">
										<router-link
												:to="{name: 'registration', params: {id: data.item.recordId}}">
											<font-awesome-icon icon="eye"></font-awesome-icon>
										</router-link>
									</template>
								</b-table>
							</div>
						</div>
					</div>-->

					<!--Job-->
					<div class="card">
						<div class="card-header pb-2 pt-2">Active Jobs</div>
						<div class="card-body pt-2">
							<b-table
									id="job-table"
									:fields="jobFields "
									:items="record.portalData.Job"
									:per-page="jobRowsPerPage"
									:current-page="jobPage"
									primary-key="Job::Job::__PKJobID"
									small
									responsive
									hover
							>
								<template v-slot:cell(view)="data" style="width: 28px;">
									<router-link
											:to="{name: 'job-view', params: {id: data.item.recordId}}">
										<font-awesome-icon icon="eye"></font-awesome-icon>
									</router-link>
								</template>
							</b-table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import feedbackMixin from '../mixins/feedback'
import detailViewMixin from '../mixins/detail-view'
import PortalGrid from '../components/PortalGrid'

import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'

import axios from 'axios'
import VueAxios from 'vue-axios'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import FeedbackPanel from "../components/FeedbackPanel";

Vue.component('vueDropzone', vue2Dropzone);

Vue.use(VueAxios, axios);

Vue.use(VueMoment, {
	moment,
});

export default {
	name: "Registration",
	mixins: [feedbackMixin, detailViewMixin],
	components: {FeedbackPanel, PortalGrid},
	computed: {
		jobMaxRows: function () {
			if (this.record.portalData.Job) {
				return this.record.portalData.Job.length
			} else {
				return 50
			}
		},
		dropzoneOptions: function () {
			let options = {
				url: '/3ds/api/' + this.restEntity + '/' + this.recordId + '/upload?field=Registration_Picture',
				thumbnailWidth: 150,
				maxFilesize: 0.5,
				headers: {
					Authorization: 'Bearer ' + this.token
				},
				addRemoveLinks: true,
				maxFiles: 1,
				acceptedFiles: 'image/*',
				dictInvalidFileType: 'You may only upload images',
				params: {
					field: 'Registration Picture'
				}
			};
			return options
		},
		title: function () {
			return this.record.fieldData['Registration Number']
		}
	},
	methods: {
		goToJobPage: function (event) {
			if (event) {
				this.portalProps[1].page = event.page
			}
		},
		viewRegistration: function () {
			this.showReg = true
		},
		viewUpdateRegistration: function () {
			this.showReg = false;
			this.showUpdateReg = true;
			this.resetUpdateRegistration()
		},
		uploadSuccess: function (file, response) {
			console.log(JSON.stringify(response));
			this.showUpdateReg = false;
			this.pushError({
				message: 'Update Succeeded',
				type: 'SUCCESS'
			});
			this.updateRecord({
				recordId: this.recordId
			})
		},
		uploadError: function (file, message, xhr) {
			console.error(JSON.stringify(message));
			this.pushError({
				message: 'Update Failed: ' + message,
				type: 'DANGER'
			});
			this.$refs.myVueDropzone.removeFile(file)
		},
		fileAdded: function (file) {
			this.clearErrors()
		},
		resetUpdateRegistration: function () {
			this.clearErrors();
			this.$refs.myVueDropzone.removeAllFiles()
		}
	},
	data() {
		return {
			restEntity: 'registration',
			showReg: false,
			showUpdateReg: false,
			hideRegFooter: true,
			value1: 0,
			portals: [
				{
					name: 'Registration_Information_Record_Num',
				},
				{
					name: 'Job'
				}
			],
			regFields: [
				{
					key: 'view',
					label: '',
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'Registration_Information_Record_Num::Activity',
					label: 'License Type',
					sortable: true
				},
				{
					key: 'Registration_Information_Record_Num::Registration Number',
					label: 'Registration Number',
					sortable: true
				},
				{
					key: 'Registration_Information_Record_Num::Expiration Date',
					label: 'Expiration Date',
					sortable: true
				},

			],
			regPage: 1,
			regRowsPerPage: 10,
			jobFields: [
				{
					key: 'view',
					label: '',
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'Job::__PKJobID',
					label: 'ID',
					sortable: true
				},
				{
					key: 'Job::Job Name',
					label: 'Name',
					sortable: true
				},
				{
					key: 'Job::Date Job Initiated',
					label: 'Initiated',
					sortable: true
				}

			],
			jobPage: 1,
			jobRowsPerPage: 10
		}
	}

}
</script>

<style scoped>
.reg-label {
    font-weight: bold;
    margin-bottom: 0;
}

#reg-field > div > div > div {
    min-height: 24px;
}

#reg-field > div > div {
    margin-bottom: 0.5em;
}

.my-modal-wrap {
    top: 75px !important;
    text-align: center;
}
</style>